import type { IconProps } from '@/components/CustomIcon/types';

export const CheckIcon = ({ size = 20, className, ...props }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M13.3333 6.66667C13.3333 7.98521 12.9423 9.27414 12.2098 10.3705C11.4773 11.4668 10.4361 12.3213 9.21789 12.8259C7.99972 13.3304 6.65927 13.4625 5.36607 13.2052C4.07286 12.948 2.88497 12.3131 1.95262 11.3807C1.02027 10.4484 0.385336 9.26047 0.128101 7.96727C-0.129134 6.67406 0.00288856 5.33362 0.507473 4.11544C1.01206 2.89727 1.86654 1.85608 2.96287 1.12354C4.0592 0.390993 5.34813 0 6.66667 0C7.54215 0 8.40906 0.172438 9.21789 0.50747C10.0267 0.842501 10.7617 1.33356 11.3807 1.95262C11.9998 2.57168 12.4908 3.30661 12.8259 4.11544C13.1609 4.92428 13.3333 5.79119 13.3333 6.66667V6.66667ZM6.46667 9.14L10.4667 5.14C10.5908 5.01509 10.6605 4.84612 10.6605 4.67C10.6605 4.49388 10.5908 4.32491 10.4667 4.2V4.2C10.3418 4.07583 10.1728 4.00614 9.99667 4.00614C9.82055 4.00614 9.65158 4.07583 9.52667 4.2L6 7.72667L3.8 5.52667C3.67535 5.40113 3.50594 5.33025 3.32903 5.32963C3.15212 5.329 2.98221 5.39868 2.85667 5.52333C2.73113 5.64798 2.66026 5.8174 2.65963 5.99431C2.65901 6.17122 2.72868 6.34113 2.85334 6.46667V6.46667L5.52 9.13333C5.58154 9.19626 5.65492 9.24637 5.73592 9.28079C5.81692 9.31521 5.90394 9.33325 5.99195 9.33387C6.07996 9.33449 6.16722 9.31768 6.24869 9.2844C6.33017 9.25113 6.40426 9.20205 6.46667 9.14Z"
        fill="currentColor"
      />
    </svg>
  );
};
